import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  Input,
} from "reactstrap";
import { FiEdit, FiTrash, FiPlus } from "react-icons/fi";
import { updatePairsByUniqueStockID } from "../../../helpers/urlConfig/apiFunctions";
import { successToastify } from "../../../Components/Common/Toaster";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

const PairsModal = ({
  pairs,
  uniqueStockID,
  pairs_modal_list,
  tog_pairs,
  fetchData,
  keyName = null,
}) => {
  const [pairsState, setPairsState] = useState(
    typeof pairs === "string" ? JSON.parse(pairs) : pairs
  );
  const [editIndex, setEditIndex] = useState(null);
  const [editablePair, setEditablePair] = useState({ huid: "", gram: "" });
  const [newPair, setNewPair] = useState({ huid: "", gram: "" });

  const handleEdit = (index) => {
    setEditIndex(index);
    setEditablePair({ ...pairsState[index] });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditablePair((prev) => ({ ...prev, [name]: value }));
  };

  const handleNewPairChange = (e) => {
    const { name, value } = e.target;
    setNewPair((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = (index) => {
    const updatedPairs = [...pairsState];
    updatedPairs[index] = editablePair;
    setPairsState(updatedPairs);
    setEditIndex(null);
  };

  // const handleDelete = (index) => {
  //   const updatedPairs = pairsState.filter((_, i) => i !== index);
  //   setPairsState(updatedPairs);
  //   setEditIndex(null);
  // };

  const handleAddNewPair = () => {
    if (newPair.huid && newPair.gram) {
      setPairsState((prev) => [...prev, newPair]);
      setNewPair({ huid: "", gram: "" });
    }
  };

  const handleDelete = (index) => {
    if (window.confirm("Are you sure you want to delete this pair?")) {
      const updatedPairs = pairsState.filter((_, i) => i !== index);
      setPairsState(updatedPairs);
      setEditIndex(null);
    }
  };

  const handleUpdateClick = async () => {
    try {
      const data = {
        unique_stock_id: uniqueStockID,
        pairs: JSON.stringify(pairsState),
      };

      const response = await updatePairsByUniqueStockID(data);
      if (response.statusCode === 200) {
        successToastify("Pairs updated successfully");
        tog_pairs();
        fetchData();
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error("Error While Updating pairs", error.message);
    }
  };

  return (
    <Modal isOpen={pairs_modal_list} toggle={tog_pairs} size="lg">
      <ModalHeader toggle={tog_pairs}>
        Sets Details - {uniqueStockID}
      </ModalHeader>
      <ModalBody>
        <Table bordered>
          <thead>
            <tr>
              <th>#</th>
              <th>HUID</th>
              <th>Gram</th>
              {keyName !== "Sales" ? <th>Actions</th> : ""}
            </tr>
          </thead>
          <tbody>
            {Array.isArray(pairsState) &&
              pairsState.map((pair, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    {editIndex === index ? (
                      <Input
                        type="text"
                        name="huid"
                        value={editablePair.huid}
                        onChange={handleChange}
                      />
                    ) : (
                      pair.huid
                    )}
                  </td>
                  <td>
                    {editIndex === index ? (
                      <Input
                        type="text"
                        name="gram"
                        value={editablePair.gram}
                        onChange={handleChange}
                      />
                    ) : (
                      pair.gram
                    )}
                  </td>
                  <td>
                    {editIndex === index && keyName !== "Sales" ? (
                      <>
                        <Button
                          color="success"
                          size="sm"
                          onClick={() => handleSave(index)}
                        >
                          Save
                        </Button>{" "}
                        <Button
                          color="secondary"
                          size="sm"
                          onClick={() => setEditIndex(null)}
                        >
                          Cancel
                        </Button>
                      </>
                    ) : (
                      keyName !== "Sales" && (
                        <>
                          <FiEdit
                            className="action-icon"
                            onClick={() => handleEdit(index)}
                          />{" "}
                          <FiTrash
                            className="action-icon"
                            onClick={() => handleDelete(index)}
                          />
                        </>
                      )
                    )}
                  </td>
                </tr>
              ))}
            {/* <tr>
              <td>New</td>
              <td>
                <Input
                  type="text"
                  name="huid"
                  placeholder="Enter HUID"
                  value={newPair.huid}
                  onChange={handleNewPairChange}
                />
              </td>
              <td>
                <Input
                  type="text"
                  name="gram"
                  placeholder="Enter Gram"
                  value={newPair.gram}
                  onChange={handleNewPairChange}
                />
              </td>
              <td>
                <Button color="primary" size="sm" onClick={handleAddNewPair}>
                  <FiPlus /> Add
                </Button>
              </td>
            </tr> */}
          </tbody>
        </Table>
        {keyName !== "Sales" && (
          <div>
            <Button
              onClick={handleUpdateClick}
              style={{ display: "flex", justifyItems: "center" }}
            >
              Update
            </Button>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default PairsModal;
